
export const canEditField = (canEditSecureFields: boolean, availableFields: string[], mustEdit: boolean) => (fieldName: string): boolean => {
  if (mustEdit || canEditSecureFields) {
    return true;
  }

  return availableFields.includes(fieldName);
};
